module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki01_sp-4a963b6bff45ff3e2665287835910a5e.jpg";